import React from "react";
import { Search } from "lucide-react";

interface SearchPhoneInputProps {
  searchPhone: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onReset: () => void;
  className?: string;
}

const SearchPhoneInput: React.FC<SearchPhoneInputProps> = ({
  searchPhone,
  onSearchChange,
  onReset,
  className = "",
}) => (
  <div className="mb-6 flex flex-col sm:flex-row items-center gap-3">
    <div className="relative flex-grow">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
      <input
        type="text"
        value={searchPhone}
        onChange={onSearchChange}
        placeholder="Rechercher un téléphone..."
        className={`w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-800 placeholder-gray-500 transition-colors ${className}`}
      />
    </div>
    <button
      type="button"
      onClick={onReset}
      className={`px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors ${
        className.includes("text-sm") ? "bg-gray-50 border border-gray-200 text-sm font-medium" : "bg-gray-100 shadow-sm"
      }`}
    >
      Réinitialiser
    </button>
  </div>
);

export default SearchPhoneInput;